import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../utils-consultaSeguimento'
import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

export const validatorConsultaSeguimentoPergunta13 = createValidator<ConsultaSeguimentoPergunta13Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_13_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta13Model, errors: ErrorObject<ConsultaSeguimentoPergunta13Model>) => {
    if (values?.PERGUNTA_13_HEADER === SimNaoEnum.SIM) {
      errors.PERGUNTA_13_ANDA_SEM_APOIO = required(values?.PERGUNTA_13_ANDA_SEM_APOIO)
    }
    return errors
  }
)
